import { render, staticRenderFns } from "./FreeTextQuestion.vue?vue&type=template&id=4e468ccd&"
import script from "./FreeTextQuestion.vue?vue&type=script&lang=js&"
export * from "./FreeTextQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports